import {
  Camera,
  MessageSquareQuote,
  Mic,
  PencilLine,
  Sparkles,
} from "lucide-react";

import { cn } from "@/utils/tailwind";

interface SidePatternProps {
  isReversed?: boolean;
}

const patternIcons = [MessageSquareQuote, Camera, Mic, PencilLine, Sparkles];

export function SidePattern({ isReversed }: SidePatternProps) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        "relative hidden h-full overflow-hidden lg:block",
        isReversed && "-scale-x-100",
      )}
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-secondary),transparent_68%)] opacity-70" />
      <div className="absolute inset-0 grid grid-cols-3 place-content-center gap-9 p-12 opacity-55">
        {Array.from({ length: 15 }, (_, index) => {
          const Icon =
            patternIcons[index % patternIcons.length] ?? MessageSquareQuote;
          return (
            <Icon
              key={index}
              strokeWidth={1.5}
              className={cn(
                "text-primary mx-auto size-7",
                index % 2 === 0 && "rotate-[-10deg]",
                index % 3 === 0 && "text-accent-foreground rotate-12",
              )}
            />
          );
        })}
      </div>
    </div>
  );
}
